import * as React from 'react'
// types
import { IFieldValueMapItem } from 'types/graphql'
// utils
import isEmpty from 'lodash/isEmpty'

export const useInitialValuesLoading = (
  isDataLoaded: boolean,
  fieldValues: IFieldValueMapItem[],
  initialValues: Record<string, any>
) => {
  const [isInitialsLoaded, setIsInitialsLoaded] = React.useState(false)

  React.useEffect(() => {
    if (isDataLoaded) {
      if (isEmpty(fieldValues) || !isEmpty(initialValues)) {
        setIsInitialsLoaded(true)
      }
    } else if (isInitialsLoaded) {
      setIsInitialsLoaded(false)
    }
  }, [isDataLoaded, fieldValues.length, JSON.stringify(initialValues)])

  return isInitialsLoaded
}
